import React from 'react';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import PoliticasData from '../../Components/Admin/PoliticasData/PoliticasData';

export default function Politicas() {
    return (
        <div className="containerGrid">
            <Header />

            <section className="containerSection">
                <HeaderDash />
                <div className="container">
                    <PoliticasData />
                </div>
            </section>
        </div>
    );
}
